<template>
    <div class="headline-container">
        <div class="container">
            <div class="pull-left">
                <h1>
                    {{ headline }}
                </h1>

                <breadcrumbs :links="breadcrumbs"></breadcrumbs>
            </div>

            <div class="pull-right headline-buttons">
                <slot></slot>
            </div>

            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/Layout/Breadcrumbs'

    export default {
        components: {Breadcrumbs},

        props: ['headline', 'breadcrumbs']
    }
</script>

<style>
    .headline-container {
        padding-top: 25px;
        padding-bottom: 25px;
        background-color: #000000;
        border-bottom: 1px solid #eee;
        margin-bottom: 20px;
    }

    .headline-container .breadcrumb a {
        color: #dddddd;
    }

    .headline-container .breadcrumb span {
        color: #999999;
    }

    .headline-container h1 {
        color: #ffffff;
        margin: 0;
    }

    .headline-container .headline-buttons .btn {
        margin-top: 12px;
    }

    .headline-container .headline-buttons .form-inline .btn {
        margin-top: 0;
    }
</style>
